<div class="sgt-cliente-analise-mercado-view sgt-view-layout">

    <div class="sgt-view-header">
        <nav class="sgt-header-breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    Análises de Mercado
                </li>
            </ol>
        </nav>

        <div class="sgt-header-options">
            <button type="button" class="btn btn-light" (click)="back()" *ngIf="props?.queryParams?.origin">
                <i class="fas fa-arrow-left" aria-hidden="true"></i> Voltar
            </button>
        </div>
        
        <div class="sgt-header-periodicidade" *ngIf="!props?.revisaoMode">
            <sgt-cliente-analise-mercado-periodicidade-filter
                #periodicidadeFilter
                [filter]="filterComponent?.filter"
                [isFilterInitialized]="filterComponent?.isFilterInitialized"
                (periodicidadeDataChange)="onPeriodicidadeDataChange()">
            </sgt-cliente-analise-mercado-periodicidade-filter>
        </div>

        <div class="sgt-header-revisao-info" *ngIf="props?.revisaoMode">
            <sgt-cliente-analise-mercado-revisao-header-info
                [ano]="props.anoRevisao"
                [representante]="props.representanteRevisao">
            </sgt-cliente-analise-mercado-revisao-header-info>
        </div>

        <div class="sgt-header-revisao" *ngIf="props?.showRevisao">
            <div class="sgt-header-revisao-badge">
                <sgt-cliente-analise-mercado-revisao-status-numeral-badge
                    [props]="props.revisaoAtual"
                    [styles]="{
                        fontSize: '10px'
                    }">
                </sgt-cliente-analise-mercado-revisao-status-numeral-badge>
            </div>

            <div class="sgt-header-revisao-actions">
                <sgt-cliente-analise-mercado-revisao-actions
                    [props]="props.revisaoAtual"
                    [revisaoMode]="props.revisaoMode"
                    (showInfos)="showInfosRevisoes()"
                    (abrir)="abrirRevisao()"
                    (reabrir)="reabrirRevisao()"
                    (revisar)="revisar()"
                    (confirmar)="confirmarRevisao()"
                    (aprovar)="aprovarRevisao()">
                </sgt-cliente-analise-mercado-revisao-actions>
            </div>
        </div>
    </div>

    <div class="sgt-view-filter">
        <sgt-cliente-analise-mercado-filter
            #filterComponent
            [visualizacaoModo]="modo.id"
            [visualizacaoPerspectiva]="perspectiva.id"
            [isShowRepresentantesFilter]="!props?.revisaoMode"
            (filterInitialized)="onFilterInitialized()"
            (filterChange)="onFilterChange()"
            (filterRepresentantesChange)="onFilterRepresentantesChange()"
            (filterClear)="onFilterClear()">
        </sgt-cliente-analise-mercado-filter>        
    </div> 

    <div class="sgt-view-content">
        <router-outlet></router-outlet>
    </div>
</div>

<!-- Modal para Aprovar uma Revisão -->
<sgt-cliente-analise-mercado-revisao-aprovar-modal
    #aprovarRevisaoModal
    (afterAprovar)="afterAprovarRevisao($event)">
</sgt-cliente-analise-mercado-revisao-aprovar-modal>